
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import format from 'date-fns/format'

Vue.use(AirbnbStyleDatepicker, {
    // Unfortunately we can't get these from less variables
    // They have to be in js. Please keep in sync with palette.less
    colors: {
        inRange: 'rgba(0, 126, 255, 0.7)',
        inRangeBorder: 'rgba(0, 126, 255, 0.8)',
        text: '#587287',
        selected: 'rgb(0, 126, 255)',
        selectedText: '#fff',
    },
})

const dateFormat = 'DD-MMM-YYYY'

@Component({})
export default class DateRangeInput extends Vue {
    @Prop({ type: Date, default: new Date() }) public from!: Date
    @Prop({ type: Date, default: new Date() }) public to!: Date
    @Prop(Function) public onChange!: ({ from, to }) => void
    @Prop(Function) public onClose?: () => void
    @Prop({ type: Boolean, default: false }) public startOpen?: boolean
    @Prop({ type: Number }) public offsetX?: number
    @Prop({ type: Object, default: null }) public dateRangeInputStyle?: object

    public dateOne = ''
    public dateTwo = ''
    public triggerId = ''

    constructor(props) {
        super(props)
        this.dateOne = format(this.from, 'YYYY-MM-DD')
        this.dateTwo = format(this.to, 'YYYY-MM-DD')
        this.triggerId = `date-range-${Math.round(Math.random() * 1000000)}`
    }

    public applyChange() {
        this.onChange({
            from: this.dateOne,
            to: this.dateTwo,
        })
    }

    public applyClosed() {
        if (this.onClose) {
            this.onClose()
        }
    }

    public formatDates() {
        return (
            format(this.dateOne, dateFormat) +
            (this.dateTwo ? ' - ' + format(this.dateTwo, dateFormat) : '')
        )
    }
}
